export const PRAG_PAGE_TEXT_KEYS = {
  bannerTitleFirstLine: 'page_prag_banner_title_first_line',
  bannerTitleSecondLine: 'page_prag_banner_title_second_line',
  bannerSubtitle: 'page_prag_banner_subtitle',
  lineupTitle: 'page_prag_lineup_title',
  lineupDescription: 'page_prag_lineup_description',
  whyTitle: 'page_prag_why_title',
  whyDescription: 'page_prag_why_description',
  marketingMaterialsTitleFirstLine: 'page_prag_marketing_materials_title_first_line',
  marketingMaterialsTitleSecondLine: 'page_prag_marketing_materials_title_second_line',
  marketingMaterialsDescription: 'page_prag_marketing_materials_description',
  becomePartnerTitle: 'page_prag_become_partner_title',
  becomePartnerInfoFirstLine: 'page_prag_become_partner_info_first_line',
  becomePartnerInfoSecondLine: 'page_prag_become_partner_info_second_line',
  contactUs: 'page_prag_contact_us',
  visitNow: 'page_prag_visit_now',
  goLiveDate: 'page_prag_go_live_date',
} as const;

export const PRAG_PAGE_TEXT_VALUES = {
  [PRAG_PAGE_TEXT_KEYS.bannerTitleFirstLine]: 'A new studio to',
  [PRAG_PAGE_TEXT_KEYS.bannerTitleSecondLine]: 'elevate your classic slot offering',
  [PRAG_PAGE_TEXT_KEYS.bannerSubtitle]: 'by Popok Gaming',
  [PRAG_PAGE_TEXT_KEYS.lineupTitle]: 'Prag Games Lineup',
  [PRAG_PAGE_TEXT_KEYS.lineupDescription]:
    "Your players' favorite titles are returning in brand-new, upgraded Prag versions.",
  [PRAG_PAGE_TEXT_KEYS.whyTitle]: 'why prag?',
  [PRAG_PAGE_TEXT_KEYS.whyDescription]:
    'Our new studiois created with a single focus: taking timeless casino favorites and elevating them for today’s market. We’ve stripped away unnecessary complexity to deliver pure, high-converting slot entertainment.',
  [PRAG_PAGE_TEXT_KEYS.marketingMaterialsTitleFirstLine]: 'Looking for Prag',
  [PRAG_PAGE_TEXT_KEYS.marketingMaterialsTitleSecondLine]: 'Marketing Materials?',
  [PRAG_PAGE_TEXT_KEYS.marketingMaterialsDescription]:
    'Access high-res assets, promo kits, and game info directly in our Client Area.',
  [PRAG_PAGE_TEXT_KEYS.becomePartnerTitle]: 'Become a partner',
  [PRAG_PAGE_TEXT_KEYS.becomePartnerInfoFirstLine]:
    'Developing innovative igaming solutions and delivering top-quality',
  [PRAG_PAGE_TEXT_KEYS.becomePartnerInfoSecondLine]:
    'games is what we do with our partners. Join our PopOK Gaming family.',
  [PRAG_PAGE_TEXT_KEYS.contactUs]: 'CONTACT US',
  [PRAG_PAGE_TEXT_KEYS.visitNow]: 'Visit Now',
  [PRAG_PAGE_TEXT_KEYS.goLiveDate]: 'GO LIVE DATE:',
} as const;

export const WHY_PRAG_ITEMS = [
  {
    titleKey: 'page_prag_iconic_fruit_themes_title',
    descriptionKey: 'page_prag_iconic_fruit_themes_description',
  },
  {
    titleKey: 'page_prag_simple_mechanics_title',
    descriptionKey: 'page_prag_simple_mechanics_description',
  },
  {
    titleKey: 'page_prag_frequent_wins_title',
    descriptionKey: 'page_prag_frequent_wins_description',
  },
  {
    titleKey: 'page_prag_bonus_features_title',
    descriptionKey: 'page_prag_bonus_features_description',
  },
  {
    titleKey: 'page_prag_fast_performance_title',
    descriptionKey: 'page_prag_fast_performance_description',
  },
  {
    titleKey: 'page_prag_immersive_design_title',
    descriptionKey: 'page_prag_immersive_design_description',
  },
] as const;

export const WHY_PRAG_TEXT_VALUES = {
  page_prag_iconic_fruit_themes_title: 'Iconic fruit-inspired themes',
  page_prag_iconic_fruit_themes_description:
    'Featuring familiar symbols and classNameic slot aesthetics, these games deliver the nostalgic charm players love while keeping the experience fresh and engaging.',
  page_prag_simple_mechanics_title: 'Simple, player-friendly mechanics',
  page_prag_simple_mechanics_description:
    'Designed with intuitive gameplay and easy-to-understand features, allowing players to jump in and enjoy every spin instantly.',
  page_prag_frequent_wins_title: 'High engagement through frequent wins',
  page_prag_frequent_wins_description:
    'Balanced gameplay with strong hit frequency creates consistent excitement and keeps players engaged throughout their sessions',
  page_prag_bonus_features_title: 'Enhanced gameplay with exciting bonus features',
  page_prag_bonus_features_description:
    'Unique mechanics and rewarding bonus elements add depth, variety, and extra entertainment value to every round.',
  page_prag_fast_performance_title: 'Optimized for fast and seamless performance',
  page_prag_fast_performance_description:
    'Lightweight architecture ensures quick loading times, smooth gameplay, and responsive performance across desktop and mobile platforms.',
  page_prag_immersive_design_title: 'Eye-catching visuals and immersive design',
  page_prag_immersive_design_description:
    'Bright graphics, vibrant animations, and polished details create an appealing gaming environment that captures player attention.',
} as const;
